import { HStack, Heading, Stack, VStack, useColorModeValue, Image } from '@chakra-ui/react'
import { TTTForm } from '../components'
import tttSvg from '../assets/ttt.svg'
const TicTacToe = () => {
  return (
    <VStack
      spacing={{ base: '30px' }}
      minH={{ base: '74vh', md: '74vh' }}
      wrap={'wrap'}
      align={'center'}
      justify={'center'}
      mb={'10px'}
    >
      <HStack
        minH={{ base: '74vh', md: '74vh' }}
        wrap={'wrap'}
        align={'center'}
        justify={'center'}
        mb={'10px'}
      >
        <Image src={tttSvg} boxSize={{ base: '170px', md: 'sm' }}></Image>
        <Stack
          spacing={4}
          bg={useColorModeValue('white', 'gray.700')}
          rounded={'xl'}
          boxShadow={'lg'}
          p={{ base: '6', md: '8' }}
          my={{ base: '6', md: '12' }}
        >
          <Heading
            textAlign={'center'}
            fontSize={{ base: '2xl', md: '4xl' }}
            mb={{ base: 0, md: 4 }}
            color={'brand.500'}
          >
            Tic Tac Toe ✖️⭕
          </Heading>
          <TTTForm />
        </Stack>
      </HStack>
    </VStack>
  )
}
export default TicTacToe
